import React, { FunctionComponent } from 'react';
import './TableTitle.scss';

type Props = {
  title: string;
  sortable?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const TableTitle: FunctionComponent<Props> = ({
  title,
  sortable,
  onClick = () => {},
}) => (
  <div className="table-title-container">
    <p className="title-text">{title}</p>{' '}
    {sortable && (
      <button onClick={onClick} className="sort-button" type="button">
        <div className="sort-icon-container">
          <div className="top-arrow" />
          <div className="bottom-arrow" />
        </div>
      </button>
    )}
  </div>
);
